module.exports = __webpack_public_path__ + "static/media/title_6.869ca011.svg";